<template>
  <div class="home">
    <Display />
    <div class="main-content">
      <Advertise />
      <Monetize />
      <AdUnits />
      <Games />
      <About />
    </div>
  </div>
</template>
<script>
import Advertise from "./components/Advertise";
import Monetize from "./components/Monetize";
import AdUnits from "./components/AdUnits";
import Games from "./components/Games";
import About from "./components/About";
import Display from "./components/Display";
export default {
  components: {
    Advertise,
    Monetize,
    Display,
    AdUnits,
    Games,
    About
  },
  props: {
    targetId: String
  },
  mounted () {
  // 判断commentId 是否有值，如果没有的话，就不进行跳转，我这里就用'null'来判断了，你们随意
  // document.querySelector用来获取element，有个坑，id值不能全为数字，否则报错，所以我在id值前面加了id，id格式大致是：id123456
  // scrollIntoView就是用来跳转到锚点的函数
    if (this.targetId && this.targetId.length) {
      let inter = setInterval(() => {
        let target = document.querySelector(`#${this.targetId}`)
        if (target) {
          clearInterval(inter)
          target.scrollIntoView()
        }
      },100)
    }
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  max-width: 1550px;
  margin: 0 auto;
}
</style>